/**
 * Fixed banner rendered at the top of every public proposal screen.
 * Extracted to be shared between the centered layout and the details screen.
 */
export function PublicProposalBanner() {
  return (
    <header className="bg-[#050505] text-white">
      <div className="relative mx-auto flex max-w-6xl items-center justify-center px-4 py-4 sm:px-6 sm:py-5">
        <img
          src="/logo-bws.png"
          alt="BWS IoT"
          className="absolute left-4 h-8 w-auto sm:left-6 sm:h-10"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
        <h1 className="text-base font-semibold sm:text-xl">Proposta Comercial</h1>
      </div>
    </header>
  );
}
